import { format } from "date-fns/format";
import { parseFormDateString } from "./form-date.js";
function formatItineraryLocationTitle(primaryLocation, secondaryLocation, emptyLabel = 'Where to?') {
    const primaryName = primaryLocation?.itemName;
    const secondaryName = secondaryLocation?.itemName;
    if (primaryName && secondaryName) return `${primaryName} to ${secondaryName}`;
    return primaryName || secondaryName || emptyLabel;
}
function formatItineraryDateRange(startDate, endDate, referenceDate = new Date()) {
    const from = parseFormDateString(startDate, referenceDate);
    if (!from) return;
    const to = parseFormDateString(endDate, referenceDate);
    if (!to || to.getTime() === from.getTime()) return format(from, 'EEE, MMM d');
    return `${format(from, 'EEE, MMM d')} - ${format(to, 'EEE, MMM d')}`;
}
function formatItineraryTravelers(travelers, { roomsEnabled = false } = {}) {
    if (!travelers) return;
    const travelerCount = travelers.adults + travelers.children + travelers.lapInfants;
    if (!travelerCount) return;
    const parts = [
        `${travelerCount} traveler${1 === travelerCount ? '' : 's'}`
    ];
    if (roomsEnabled && travelers.rooms) parts.push(`${travelers.rooms} room${1 === travelers.rooms ? '' : 's'}`);
    return parts.join(', ');
}
export { formatItineraryDateRange, formatItineraryLocationTitle, formatItineraryTravelers };
